export default __webpack_public_path__ + "static/media/FiraMono-Regular.68fc4c9a.ttf";